import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Coins, Gift } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/i18n";
import { Button } from "@/components/ui/button";

const LABELS = {
  ideas: { fr: "Idées proposées", en: "Ideas suggested" },
  concepts: { fr: "Styles proposés", en: "Styles suggested" },
  content: { fr: "Publication créée", en: "Post created" },
  image: { fr: "Image générée", en: "Image generated" },
  voice: { fr: "Message vocal", en: "Voice message" },
};

export default function Credits() {
  const { t, lang } = useLang();
  const nav = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/credits").then((r) => setData(r.data)); }, []);
  if (!data) return <div className="max-w-3xl mx-auto px-6 py-20 text-center text-stone-400 animate-pulse">{t("loading")}</div>;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="font-head font-black text-3xl sm:text-4xl mb-8">{t("credits_title")}</h1>
      <div className="rounded-3xl bg-primary text-white p-8 mb-6 flex items-center justify-between shadow-[0_8px_24px_0_rgba(124,58,237,0.35)]">
        <div>
          <p className="text-white/80 font-semibold">{t("credits_have")}</p>
          <p className="font-head font-black text-5xl" data-testid="credits-balance">{data.credits}</p>
          <p className="text-white/80">{t("credits_unit")}</p>
        </div>
        <Coins size={72} className="opacity-80" />
      </div>

      {data.credits < 15 && (
        <div className="rounded-2xl bg-secondary/50 border-2 border-primary/20 p-5 mb-6 flex items-center justify-between gap-4">
          <p className="font-semibold text-stone-700">{t("credits_low")}</p>
          <Button onClick={() => nav("/affiliate")} className="rounded-full bg-primary hover:bg-[#6D28D9] font-bold shrink-0"><Gift size={16} className="mr-1" />{t("nav_affiliate")}</Button>
        </div>
      )}

      <h2 className="font-head font-bold text-xl mb-4">{t("credits_hist")}</h2>
      <div className="bg-white rounded-3xl border-2 border-stone-200 divide-y divide-stone-100" data-testid="credits-history">
        {data.history.length === 0 && <div className="p-6 text-stone-400 text-center">—</div>}
        {data.history.map((h) => (
          <div key={h.id} className="flex items-center justify-between px-6 py-4">
            <span className="font-medium">{LABELS[h.action]?.[lang] || h.action}</span>
            <span className="font-bold text-primary">-{h.credits}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
